import {
  shape,
  oneOfType,
  number,
  string,
} from 'prop-types';

export const CREATE_SCHEDULE_REPORT_TITLE = 'Schedule Report';
export const frequencyWeeklyInfoLabel = 'Select which day of the week to send the report';

export const createSchedule = 'createSchedule';
export const download = 'download';
export const sendImmediately = 'sendImmediately';

export const SCHEDULE_RERORT_FREQUENCY_TYPE = {
  MONTHLY: 'monthly',
  WEEKLY: 'weekly',
};

export const SCHEDULE_REPORT_FORMAT = {
  PDF: 'pdf',
  HORIZONTAL_PDF: 'horizontal_pdf',
  VERTICAL_PDF: 'vertical_pdf',
  PPT: 'ppt',
  CSV: 'csv'
};

export const SCHEDULE_REPORT_PERIOD = {
  ENTIRE_CAPAIGN: 'entire_campaign',
  MONTH_TO_DATE: 'month_to_date',
  WEEK_TO_DATE: 'week_to_date',
  LAST_WEEK: 'last_week',
  LAST_30_DAYS: 'last_30_days',
  LAST_MONTH: 'last_month'
};

export const scheduleReportFrequencyType = [
  {
    label: 'Monthly',
    value: SCHEDULE_RERORT_FREQUENCY_TYPE.MONTHLY
  },
  {
    label: 'Weekly',
    value: SCHEDULE_RERORT_FREQUENCY_TYPE.WEEKLY
  },
];

export const scheduleReportFormatOptions = [
  // {
  //   value: SCHEDULE_REPORT_FORMAT.HORIZONTAL_PDF,
  //   label: 'PDF'
  // },
  {
    value: SCHEDULE_REPORT_FORMAT.VERTICAL_PDF,
    label: 'PDF'
  },
  {
    value: SCHEDULE_REPORT_FORMAT.PPT,
    label: 'PPT'
  },
  // {
  //   value: SCHEDULE_REPORT_FORMAT.CSV,
  //   label: 'CSV'
  // }
];

export const dayOfWeekOptions = [
  {
    value: 'Sunday',
    label: 'Su'
  },
  {
    value: 'Monday',
    label: 'M'
  },
  {
    value: 'Tuesday',
    label: 'Tu'
  },
  {
    value: 'Wednesday',
    label: 'W'
  },
  {
    value: 'Thursday',
    label: 'Th'
  },
  {
    value: 'Friday',
    label: 'F'
  },
  {
    value: 'Saturday',
    label: 'Sa'
  }
];

export const periodOptions = [
  {
    value: SCHEDULE_REPORT_PERIOD.ENTIRE_CAPAIGN,
    label: 'Campaign to date'
  },
  {
    value: SCHEDULE_REPORT_PERIOD.MONTH_TO_DATE, // From start of month to date process schedule report
    label: 'Month to date'
  },
  {
    value: SCHEDULE_REPORT_PERIOD.WEEK_TO_DATE,
    label: 'Week to date'
  },
  {
    value: SCHEDULE_REPORT_PERIOD.LAST_MONTH,
    label: 'Last Month'
  },
  {
    value: SCHEDULE_REPORT_PERIOD.LAST_WEEK,
    label: 'Last Week'
  },
  {
    value: SCHEDULE_REPORT_PERIOD.LAST_30_DAYS,
    label: 'Last 30 days'
  },
]

export const dayOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

export const scheduleReportShape = shape({
  scheduleReportTimePeriod: shape({ type: string }),
  scheduleReportId: oneOfType([string, number]),
  scheduleReportName: string,
  scheduleReportReceivers: string,
  scheduleReportFrequency: shape({
    type: string,
    data: shape({
      dayOfMonth: oneOfType([number, string]),
      dayOfWeek: string
    })
  }),
  relativeReportTime: string,
})
